import { Box } from '@factorialco/deprecated-design-system'
import { AtsUploadCvsWidgetFragment, CvBulkCandidateFragment } from 'generated/resources/graphql'
import { isNil } from 'lodash'

import Select from 'modules/core/components/Select'
import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import { getSourceLabel } from 'modules/ats/lib/utils/candidateSources'

import { FilesList } from './FilesList'
import { NewCandidatesList } from './NewCandidatesList'

interface Props {
  onClose: () => void
  cvBulkUpload: AtsUploadCvsWidgetFragment
}

export const UploadCvsSidepanel = ({ onClose, cvBulkUpload }: Props) => {
  const failedFiles = cvBulkUpload.files.filter(
    (file) =>
      !file.candidate && file.processingError && file.processingError !== 'cv_bulk_upload_cancelled'
  )

  const inProgressFiles = cvBulkUpload.files.filter(
    (file) => !file.candidate && !file.processingError
  )

  const cancelledFiles = cvBulkUpload.files.filter(
    (file) => file.processingError === 'cv_bulk_upload_cancelled'
  )

  const newCandidates = cvBulkUpload.files
    .map((file) => file.candidate)
    .filter((candidate): candidate is CvBulkCandidateFragment => !isNil(candidate))

  return (
    <Sidepanel
      open
      width="wide"
      title={i18n.t('ats.candidates.upload_resumes.sidepanel.title')}
      onClose={onClose}
      closeLabel={i18n.t('common.close')}
    >
      <Box gap="s32">
        <Select
          label={i18n.t('ats.candidates.upload_resumes.sidepanel.candidates_source')}
          options={[
            {
              label: getSourceLabel(cvBulkUpload.candidateSource?.name),
              value: cvBulkUpload.candidateSource?.id || '',
            },
          ]}
          readonly
        />

        {inProgressFiles.length > 0 && (
          <FilesList
            title={i18n.t('ats.candidates.upload_resumes.sidepanel.pending_candidates.title')}
            description={i18n.t(
              'ats.candidates.upload_resumes.sidepanel.pending_candidates.description'
            )}
            status="in_progress"
            files={inProgressFiles}
          />
        )}

        {cancelledFiles.length > 0 && (
          <FilesList
            title={i18n.t('ats.candidates.upload_resumes.sidepanel.cancelled_candidates.title')}
            description={i18n.t(
              'ats.candidates.upload_resumes.sidepanel.cancelled_candidates.description'
            )}
            status="cancelled"
            files={cancelledFiles}
          />
        )}

        {!!failedFiles.length && (
          <FilesList
            title={i18n.t('ats.candidates.upload_resumes.sidepanel.review_errors.title')}
            description={i18n.t(
              'ats.candidates.upload_resumes.sidepanel.review_errors.description'
            )}
            status="error"
            files={failedFiles}
          />
        )}

        {!!newCandidates?.length && <NewCandidatesList newCandidates={newCandidates} />}
      </Box>
    </Sidepanel>
  )
}
